import React from 'react'
import { TextField, InputAdornment, IconButton, styled } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import CloseIcon from '@mui/icons-material/Close'

interface SearchProps {
  onSearch: (term: string) => void
  searchValue: string
  placeholder?: string
  // Opt in to a clear button inside the field. Left unset the field behaves as it always has, so
  // callers with a clear control of their own are unaffected.
  onClear?: () => void
}

export const Search: React.FC<SearchProps> = ({
  onSearch,
  searchValue,
  placeholder = 'Search by ID, Name, Email and Mobile',
  onClear,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onSearch(e.target.value)
  }

  return (
    <StyledSearchField
      placeholder={placeholder}
      variant="outlined"
      value={searchValue}
      onChange={handleChange}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" />
          </InputAdornment>
        ),
        endAdornment:
          onClear && searchValue ? (
            <InputAdornment position="end">
              <IconButton aria-label="Clear search" size="small" edge="end" onClick={onClear}>
                <CloseIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ) : undefined,
      }}
    />
  )
}

const StyledSearchField = styled(TextField)({
  width: '340px',
  '& .MuiOutlinedInput-input': {
    fontSize: '14px',
    padding: '9px',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      border: '1px solid #E4E7EC',
      borderRadius: '8px',
    },
    '&.Mui-focused fieldset': {
      border: '1px solid #E4E7EC',
    },
    '&:hover fieldset': {
      border: '1px solid #E4E7EC',
    },
  },
})
